import type { DynamicEntityListTableColumn } from '@web-config-app/core';

/**
 * Type guard to check if a column is a dynamic column (has a `path` property)
 * vs a default column (has a `key` property)
 */
export const isDynamicColumn = (
  column: unknown,
): column is DynamicEntityListTableColumn =>
  column !== null &&
  column !== undefined &&
  typeof column === 'object' &&
  'path' in column;
